// What `form.render()` returns (spec §8): the title, the description, the groups, the form-level error, the captcha slot and
// the submit button - or, after a successful send, the thank-you message. Pure of the snapshot and the actions it is given.
import { h } from "./h.js";
import { scope_props } from "./styles.js";
import { label_of, first_error_text } from "./messages.js";
import { Group } from "./Group.js";
import { groups_of } from "./form_logic.js";
import { dom_id } from "./fields/shell.js";

export const FormView = (props) => {
    const {
        definition, snapshot, actions, form_id, lang, messages, styles, class_names, geo, custom_fields,
        captcha_node, needs_login = false, submit_label, success_content, title_tag = "h2", hide_title = false, max_file_bytes, price_unit, field_components,
    } = props;
    const scope = (slot, extra) => scope_props({ scope: "form", slot, class_names, styles, extra });

    if (snapshot.submitted) {
        return h(
            "div",
            { ...scope("success"), role: "status", "data-form-key": definition?.key, "data-duplicate": snapshot.duplicate ? "true" : undefined },
            success_content ?? h("p", null, label_of("success", lang, messages)),
            h("button", { type: "button", ...scope("submit", class_names?.secondary_button), onClick: () => actions.reset() }, label_of("another", lang, messages)),
        );
    }

    const form_error = first_error_text(snapshot.errors?._form, lang, messages);
    const title_id = dom_id(form_id, "title");
    return h(
        "form",
        {
            ...scope("root"),
            noValidate: true,
            lang: definition?.lang || undefined,
            "aria-labelledby": definition?.title && !hide_title ? title_id : undefined,
            "aria-busy": snapshot.submitting ? "true" : undefined,
            "data-form-key": definition?.key,
            "data-form-id": definition?.id,
            onSubmit: (event) => {
                if (event && typeof event.preventDefault === "function") {
                    event.preventDefault();
                }
                actions.submit();
            },
        },
        definition?.title && !hide_title ? h(title_tag, { id: title_id, ...scope("title") }, definition.title) : null,
        definition?.description ? h("p", scope("description"), definition.description) : null,
        needs_login ? h("p", { ...scope("notice"), role: "status" }, label_of("login_notice", lang, messages)) : null,
        ...groups_of(definition?.version).map((group) => h(Group, {
            key: group.key, group, snapshot, actions, form_id, lang, messages, styles, class_names, geo, custom_fields, field_components, max_file_bytes, price_unit,
        })),
        form_error ? h("p", { id: dom_id(form_id, "form-error"), role: "alert", ...scope("error") }, form_error) : null,
        captcha_node || null,
        h(
            "div",
            scope("actions"),
            h("button", {
                type: "submit",
                ...scope("submit"),
                disabled: snapshot.submitting ? true : undefined,
                "aria-describedby": form_error ? dom_id(form_id, "form-error") : undefined,
            }, snapshot.submitting ? label_of("submitting", lang, messages) : (submit_label || label_of("submit", lang, messages))),
        ),
    );
};
